import { inject, isDevMode, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
//import { MarkdownModule } from 'ngx-markdown';
import { provideFuse } from '@fuse';
import { CoreModule } from 'app/core/core.module';
import { appConfig } from 'app/core/config/app.config';
import { mockApiServices } from 'app/api';
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { ColorPickerModule } from '@iplab/ngx-color-picker';
import { HTTP_INTERCEPTORS, HttpClient, HttpHeaders, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APOLLO_OPTIONS, provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApolloLink, InMemoryCache } from "@apollo/client";
import { setContext, SetContextLink } from '@apollo/client/link/context';
import { ErrorLink, onError } from '@apollo/link-error';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MAT_CHIPS_DEFAULT_OPTIONS } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ApiInterceptorService } from './api-interceptor.service';
import { environment } from '../environments/environment';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { CustomMatPaginatorIntl } from './shared/utils/custom.paginator';
import { CommonSharedModule } from './modules/admin/shared/shared.module';
import { LayoutComponent } from './layout/layout.component';
import { HelpWidgetComponent } from './common/help-widget/help-widget.component';
import { provideZoneChangeDetection } from '@angular/core';

const uri = environment.tbsBaseURL;

export function rootLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/', '.json')
}

export function createApollo(): any {
    const httpLink = inject(HttpLink);
    const uri = environment.tbsBaseURL;

    // 1. Error Link (Handles GraphQL and Network errors)
    const linkError = new ErrorLink(({ graphQLErrors, networkError }) => {
        if (graphQLErrors)
            graphQLErrors.map(({ message, locations, path }) =>
                console.log(
                    `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
                ),
            );

        if (networkError) console.log(`[Network error]: ${networkError}`);
    });
    // 2. Auth & Basic Headers Link
    const auth = new SetContextLink((_operation, _context) => {
        const token = localStorage.getItem('token');
        const tier = localStorage.getItem('Tier');

        if (!token) return {};

        return {
            headers: new HttpHeaders({
                Authorization: token,
                apikey: environment.apiKey,
                tier: tier || 'standard',
                'X-Local-Language': `${localStorage.getItem('langLocale') || 'en'}`
            })
        };
    });

    const basic = new SetContextLink((operation, context) => ({
        headers: new HttpHeaders({
            Accept: 'charset=utf-8'
        })
    }));
    // 3. HTTP Link (Sends the request to the GraphQL server)
    const link = ApolloLink.from([
        basic,
        auth,
        httpLink.create({ uri })
    ]);

    return {
        // IMPORTANT: The order matters. Error link should be first to catch issues.
        link: link,
        linkError: linkError,
        cache: new InMemoryCache(),
        defaultOptions: {
            watchQuery: { fetchPolicy: 'no-cache' },
            query: { fetchPolicy: 'no-cache' }
        }
    };
}

// const link = ApolloLink.from([basic]);

const routerConfig: ExtraOptions = {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled'
};

@NgModule({
    declarations: [
        AppComponent,
        // ProfilesComponent,
        // GenerateApiKeyComponent,
    ],
    bootstrap: [
        AppComponent
    ], imports: [BrowserModule,
        ColorPickerModule,
        // FormWizardModule,
        HelpWidgetComponent,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),
        CommonSharedModule,
        FormsModule,
        // Core module of your application
        CoreModule,
        // Layout module of your application
        LayoutComponent,
        MatSnackBarModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: true }),
        // 3rd party modules that require global configuration via forRoot
        //MarkdownModule.forRoot({}),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: rootLoaderFactory,
                deps: [HttpClient]
            }
        })], providers: [
            provideApollo(createApollo),
            {
                provide: MAT_CHIPS_DEFAULT_OPTIONS,
                useValue: {
                    separatorKeyCodes: [ENTER, COMMA]
                }
            },
            {
                provide: HTTP_INTERCEPTORS,
                useClass: ApiInterceptorService,
                multi: true
            },
            {
                provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl
            },
            //provideHttpClient(),
            //provideTransloco(),
            provideFuse({
                fuse: appConfig,
                mockApi: {
                    delay: 0,
                    service: mockApiServices,
                }
            }),
            provideZoneChangeDetection(),
            provideEnvironmentNgxMask(),
            provideHttpClient(withInterceptorsFromDi())
        ]
})
export class AppModule {
}
